import { render } from "./PatientCard.vue?vue&type=template&id=263250b7&scoped=true"
import script from "./PatientCard.vue?vue&type=script&lang=js"
export * from "./PatientCard.vue?vue&type=script&lang=js"

import "./PatientCard.vue?vue&type=style&index=0&id=263250b7&lang=scss&scoped=true"
import "./PatientCard.vue?vue&type=style&index=1&id=263250b7&lang=scss"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263250b7"]])

export default __exports__